import React from 'react';
import { Avatar, ToolbarButton } from '@fourthwall/components';
import { CloseIcon } from '@fourthwall/icons';
import * as S from './styled';
export const SelectedMember = ({ nickname, avatarUrl, onRemove }) => (React.createElement(S.Container, null,
    React.createElement(Avatar, { name: nickname, imageUrl: avatarUrl }),
    React.createElement(S.Nickname, null, nickname),
    React.createElement(ToolbarButton, { icon: CloseIcon, onClick: onRemove })));
